import { colors } from '@/styles';
import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@material-ui/core';
import { css } from '@emotion/react';

const TextParameter = ({ value, ...props }) => {
    return (
        <TextField
            fullWidth
            size="small"
            variant="outlined"
            InputLabelProps={{ shrink: !!props.placeholder || !!props.value }}
            error={props.required && !value}
            value={value || ''}
            {...props}
        />
    );
};

const SingleDateParameter = ({ value, ...props }) => {
    return (
        <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            InputLabelProps={{ shrink: true }}
            error={props.required && !value}
            value={value || ''}
            {...props}
        />
    );
};

const MultiSelectParameter = ({ options, label, value, ...props }) => {
    const sanitized = value || [];
    return (
        <FormControl variant="outlined" fullWidth size="small">
            <InputLabel id={`label-${label}`}>{label}</InputLabel>
            <Select
                labelId={`label-${label}`}
                multiple
                renderValue={(selected) => {
                    if (selected.length === 1) return options.find((option) => option.value === selected[0]).label;
                    return `${selected.length} Selected`;
                }}
                // MenuProps={{ PaperProps: { style: { maxHeight: '50%' } } }}
                MenuProps={{
                    style: { maxHeight: '50%' },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                }}
                InputLabelProps={{ shrink: !!sanitized.length }}
                input={<OutlinedInput label={label} />}
                value={sanitized}
                {...props}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.value}
                        value={option.value}
                        css={css`
                            & .Mui-checked {
                                color: ${colors.greens.primary};
                            }
                        `}
                    >
                        <Checkbox checked={sanitized.indexOf(option.value) >= 0} />
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export const renderParameter = ({ type, ...props }) => {
    switch (type) {
        case 'text':
            return <TextParameter {...props} />;
        case 'date':
            return <SingleDateParameter {...props} />;
        case 'multiselect':
            return <MultiSelectParameter {...props} />;
        case 'select':
        case 'number':
        case 'datetime':
        default:
            console.error('not implemented');
            return null;
    }
};
